import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, RegularShape } from 'ol/style.js';
import GeoJSON from "ol/format/GeoJSON";
import { Circle as CircleStyle, Text } from 'ol/style';
import { easeOut } from 'ol/easing.js';
import { fromLonLat } from 'ol/proj.js';
import { getVectorContext } from 'ol/render.js';
import { unByKey } from 'ol/Observable.js';
import { hexToRgba, settingsConfig } from 'utils/commonFunc';
import { reverseProgressValue, runAnimationFeature, setMapSingleEventHandler } from 'map/OlExtension'
import { Feature } from 'ol';
import { LineString, Point } from 'ol/geom';

export default class BoundaryFacilityStatusLayer extends VectorLayer {
    styleGray = new Style({
        stroke: new Stroke({
            color: 'rgba( 200, 200, 200, 0.9)',
            width: 1
        }),
        fill: new Fill({
            color: 'rgba( 200, 200, 200, 0.7)'
        })
    });

    constructor(map) {
        super({
            name: 'boundaryFacilityStatusLayer',
            source: new VectorSource(),
            //style: (feature) => this.styleFunction(feature),
        });
        this.map = map;
        this.map?.addLayer(this);
    }

    styleFunction = function (feature) {
        const properties = feature.get('properties');
        const valid = properties.comm;

        if (!valid) {
            const id = properties.id;
            const location = properties.location;
            return new Style({
                // text: new Text({
                //     font: "14px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
                //     fill: new Fill({
                //         color: "rgb(255, 255, 255)"
                //     }),
                //     stroke: new Stroke({
                //         color: "rgb(100, 100, 100)",
                //         width: 1
                //     }),
                //     padding: [3, 3, 2, 6],
                //     textBaseline: "top",
                //     offsetY: 0,
                //     text: `${location}`
                // }),
                image: new RegularShape({
                    radius: 10,
                    points: 3,
                    angle: Math.PI,
                    displacement: [0, 5],
                    fill: new Fill({
                        color: "rgba(255, 25, 25, 0.7)"
                    }),
                    stroke: new Stroke({
                        color: "rgba(255, 25, 25, 1)",
                        width: 1
                    })
                }),
                geometry: feature.getGeometry(),
                zIndex: 1
            })
        }
       
        return new Style({
            image: new RegularShape({
                radius: 10,
                points: 3,
                angle: Math.PI,
                displacement: [0, 5],
                fill: new Fill({
                    color: "rgba(25, 255, 25, 0.5)"
                }),
                stroke: new Stroke({
                    color: "rgba(25, 255, 25, 1)",
                    width: 1
                })
            }),
            geometry: feature.getGeometry(),
            zIndex: 0
        })
    };

    UpdateFacilityStatus = (data) => {
        const source = this.getSource()
        source.clear();

        data.forEach(feature => feature.setStyle(this.styleFunction(feature)))

        source.addFeatures(data)
        this.startAnimationFeature();
    }

    startAnimationFeature = () => {
        runAnimationFeature(this, 'animationKey', 600, (feature, hashTable) => {
            const radius = hashTable.radius
            const style = feature.getStyle();
                const fill = style.getImage().getFill();
                const stroke = style.getImage().getStroke();
                style.setImage(new RegularShape({
                    radius: radius,
                    points: 3,
                    angle: Math.PI,
                    displacement: [0, radius / 2],
                    fill: fill,
                    stroke: stroke
                }))
                feature.setStyle(style);                
        }, {
            progressCallBack: (progress, hashTable) => {
                hashTable.radius = 14 * reverseProgressValue(progress, 0.8)
            }
        });
    }
}